// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9c0257ff","455":"73bd777f","977":"d5801a2a"}[chunkId] + ".chunk.js";
};